export const EmailModel = {
    nome: "",
    email: "",
    telefone: "",
    destinatario: 0,
    mensagem: ""
  };